module.exports = __webpack_public_path__ + "img/new_6.f676122e.jpeg";